import request from '@/utils/request'

// 获取当前用户的基本(员工）信息
export function getEmployeeInfoApi() {
  return request({
    url: '/enterprise/employees/oneself',
    method: 'get'
  })
}

// 获取加入的公司
export function getJoinCompanyApi() {
  return request({
    url: '/users/oneself/join-company',
    method: 'get'
  })
}

// 选择企业进入公司
export function enterCompanyApi(data) {
  return request({
    url: '/users/oneself/enter-company',
    method: 'post',
    headers: {
      'Content-Type': 'application/json'
    },
    data
  })
}
